import StringMask from "string-mask";

export const getStringMask = () => StringMask;
